export enum ScreenPaths {
    UserConfig = '/user-configuration',
    TeamConfig = '/team-configuration',
    WorkItemStatesConfig = '/workitem-configuration',
    TargetsConfig = '/target-configuration'
}

export enum PageType {
    PERFORMANCE_DASHBOARD = "Performance_Dashboard",
    WIP_DASHBOARD = 'WIP_Dashboard',
}